<template>
  <div class="card1">
    <div class="zhuanti" v-if="item.zhuanti">专题</div>
    <div class="flex_row">
      <div class="bg" :style="{backgroundImage: 'url(' + cover(item) + ')'}" @click.stop="goDetail">
        <div class="play_icon" v-if="!isNft && (item.type === 1 && item.playIcon || item.type === 2)"></div>
        <div class="audio_icon" v-if="!isNft && (item.type === 5 || item.type === 25)"></div>
        <div class="nft_icon" v-if="isNft"></div>
      </div>
      <div class="flex1 flex_column" style="justify-content: space-between;">
        <div class="title two_line" @click.stop="goDetail">{{ item.title }}</div>
        <div class="otherInfo">
          <div class="sourceInfo flex_row flex_center">
            <div class="flex_row flex_center">
              <div class="logo_box" v-if="userInfo(item).logo !== ''">
                <img class="sourceImg" :src="userInfo(item).logo" alt="" v-if="userInfo(item).logo">
                <img class="v_icon" :src="item.xinhua.vimgUrl" alt=""
                     v-if="item.xinhua && item.xinhua.vflag">
              </div>
              <div class="sourceName one_line">
                {{ userInfo( item ).name }}
              </div>
            </div>
            <div class="sourceName" v-if="item.commentNum">{{ item.commentNum }}评</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card1',
  props: [ 'item' ],
  computed: {
    // 是否是数藏稿
    isNft () {
      return this.item.type === 1 &&
        this.item.isLink &&
        this.item.content.indexOf( 'https://my-h5news-test.app.xinhuanet.com/xhdc/' ) === 0
    },
  },
  methods: {
    // 背景图
    cover ( item ) {
      if ( item.cover !== '' ) {
        return item.cover
      } else {
        return 'https://my-statics-cdn.app.xinhuanet.com/uploadfile/h5/lianghui2021/images/default.png'
      }
    },

    // 用户信息
    userInfo ( item ) {
      let userInfo = {
        logo: '',
        name: item.sourceName
      }
      if ( item.cuser ) {
        userInfo.logo = item.cuser.logo
        userInfo.name = item.cuser.name
        userInfo.uuid = item.cuser.cuserThirdId
      }
      if ( item.xinhua ) {
        userInfo.logo = item.xinhua.xinhuaCover
        userInfo.name = item.xinhua.xinHuaName
        userInfo.uuid = item.xinhua.xinHuaUuid
      }
      return userInfo
    },
    // 打开详情
    goDetail () {
      this.$emit( 'pauseMedia' )
      window.goDetail( this.item )
    }
  }
}
</script>

<style scoped>
.card1 {
  width: 100%;
  height: 93px;
  background-image: url("../../../assets/images1/recommend/showType1_bg.png");
  background-size: cover;
  padding: 5px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  margin-bottom: 12px;
  border-radius: 12px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 6%);
}

.zhuanti {
  width: 52px;
  margin-left: 16px;
  margin-bottom: 6px;
  background-color: rgba(0, 139, 255, 0.1);
  border-radius: 10px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #008BFF;
}

.bg {
  flex-shrink: 0;
  width: 122px;
  height: 71px;
  background-size: cover;
  border-radius: 12px;
  margin-right: 12px;
  position: relative;
}

.play_icon {
  width: 22px;
  height: 22px;
  background-image: url("../../../assets/images1/recommend/video_play.png");
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  position: absolute;
  left: 4px;
  bottom: 4px;
  z-index: 1;
}

.audio_icon {
  width: 22px;
  height: 22px;
  background-image: url("../../../assets/images1/recommend/audio_play.png");
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  position: absolute;
  left: 4px;
  bottom: 4px;
  z-index: 1;
}

.nft_icon {
  width: 32px;
  height: 16px;
  background-image: url("../../../assets/images1/card/nft_icon.png");
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  position: absolute;
  left: 4px;
  bottom: 4px;
  z-index: 1;
}

.title {
  margin-top: 7px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
  margin-bottom: 12px;
}

.otherInfo {
  display: flex;
  align-items: center;
}

.sourceInfo {
  font-size: 12px;
  line-height: 18px;
  color: rgba(255, 255, 255, .65);
  font-weight: 400;
}

.logo_box {
  width: 20px;
  height: 19px;
  margin-right: 5px;
  position: relative;
}

.sourceImg {
  width: 18px;
  height: 18px;
  display: block;
  border-radius: 50%;
  object-fit: cover;
}

.logo_box {
  width: 20px;
  height: 19px;
  margin-right: 10px;
  position: relative;
}

.v_icon {
  width: 8px;
  height: 8px;
  object-fit: cover;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.sourceName {
  flex-shrink: 0;
  margin-right: 8px;
  color: rgba(255, 255, 255, .65);
}
</style>